import {
  ApolloClient,
  InMemoryCache,
  defaultDataIdFromObject,
  NormalizedCacheObject,
  from,
  HttpLink
} from '@apollo/client';
import { getEnvConfig } from '../config/config';
import { getTeamConfig } from '../config/config';

const cache = new InMemoryCache({
  typePolicies: {},
  dataIdFromObject: o => {
    switch (o.__typename) {
      default:
        return defaultDataIdFromObject(o);
    }
  }
});

export const createClient = () => {
  const client: ApolloClient<NormalizedCacheObject> = new ApolloClient({
    link: from([
      new HttpLink({
        uri: getEnvConfig()?.teamsAPI
      })
    ]),
    cache
  });

  return client;
};

export const createDualMatchesClient = () => {
  const client: ApolloClient<NormalizedCacheObject> = new ApolloClient({
    link: from([
      new HttpLink({
        uri: getEnvConfig()?.dualMatchesAPI,
        headers: {
          'x-clubspark-provider-id': getTeamConfig()?.teamId
        }
      })
    ]),
    cache
  });

  return client;
};

export const createTennisDataClient = () => {
  const client: ApolloClient<NormalizedCacheObject> = new ApolloClient({
    link: from([
      new HttpLink({
        uri: getEnvConfig()?.tennisDataAPI
      })
    ]),
    cache,
    resolvers: {},
    connectToDevTools: true
  });

  return client;
};

export default createClient;
